import { useApolloClient, useMutation } from "@apollo/client";
import { Link, Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import React, { ChangeEvent, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import ShareholderPercent from "./ShareholderPercent";
import {
  SignupProgression,
  SignupProgressionVariables,
} from "../../graphql/account/types/SignupProgression";
import { MemberInfo } from "../../graphql/onboarding/member/types/MemberInfo";
import {
  CreateMember,
  CreateMemberVariables,
} from "../../graphql/onboarding/member/types/CreateMember";
import {
  CREATE_MEMBER,
  DELETE_MEMBER,
  SHARES_PERCENTS,
} from "../../graphql/onboarding/member/mutation";
import { addOrUpdateObject } from "../../utils/table";
import { SapheerError } from "../../enums/error";
import { signupProgression } from "../../enums/account";
import {
  SharesPercents,
  SharesPercentsVariables,
} from "../../graphql/onboarding/member/types/SharesPercents";
import { arroundNumber } from "../../utils/number";
import { DocumentTypeInfo } from "../../graphql/onboarding/document/types/DocumentTypeInfo";
import { FileInterfaceLinkcy } from "../../interface/FileInterface";
import { fileToBase64 } from "../../utils/fileUtils";
import {
  CreateUserInput,
  InputDocument,
} from "../../types/graphql-global-types-onboarding";
import { DocumentType } from "../../enums/document";
import { SelectItemInterface } from "../../interface/SelectItemInterface";
import { mappedMember } from "./logic";
import {
  CreatePaymentStripe,
  CreatePaymentStripeVariables,
} from "../../graphql/onboarding/stripe/types/CreatePaymentStripe";
import { CREATE_PAYMENT_STRIPE } from "../../graphql/onboarding/stripe/mutation";
import {
  DeleteMember,
  DeleteMemberVariables,
} from "../../graphql/onboarding/member/types/DeleteMember";
import FileUploadLinkcy from "../Common/FileUpload/FileUploadLinkcy";
import { SIGNUP_PROGRESSION } from "../../graphql/account/mutation";
import { emptyShareholder } from "../StepSix/StepSixLogic";
import AddUboModal from "./AddUbo/AddUbo";
import { CustomButton } from "../Ui/CustomButton";
import CustomCheckBox from "../Ui/CustomCheckBox";
import { useToastNotifications } from "../../utils/toastUtils";
import { checkValidNumber } from "../../utils/phone";
import {
  CREATE_USER,
  SHARESHOLDERS_PERCENTS,
} from "../../graphql/onboarding/user/mutation";
import {
  CreateUser,
  CreateUserVariables,
} from "../../graphql/onboarding/user/types/CreateUser";
import {
  SharesholdersPercents,
  SharesholdersPercentsVariables,
} from "../../graphql/onboarding/user/types/SharesholdersPercents";
import { UserInfo } from "../../graphql/onboarding/user/types/UserInfo";
import { DocumentsType_documentsType } from "../../graphql/onboarding/document/types/DocumentsType";

const styles = makeStyles((theme) => ({
  addCapital: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  addButton: {
    margin: theme.spacing(1, 0),
    textTransform: "none",
    boxShadow: "none",
    "@media (max-width: 815px)": {
      width: "100%",
      marginRight: theme.spacing(1),
      marginLeft: "-8px",
    },
  },
  underLine: {
    textDecoration: "underline",
  },
  onHoverPointer: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  bolder: {
    fontWeight: "bold",
  },
  first: {
    minWidth: "65%",
    paddingRight: theme.spacing(2),
  },
  second: {
    flexGrow: 1,
    paddingLeft: theme.spacing(2),
    borderLeft: "1px solid #E8E7F5",
    "@media (max-width: 1043px)": {
      display: "none",
    },
  },
  checkbox: {
    "& label>span:first-of-type": {},
  },
  edit: {
    paddingTop: "4px",
    textAlign: "start",
    "@media(max-width:780px)": {
      textAlign: "center",
    },
  },
  sharesList: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexDirection: "column",
  },
  sharesDetail: {
    width: "100%",
  },
  text: {
    fontSize: ".875rem",
    lineHeight: 1.5,
    whiteSpace: "normal", // Autorise le retour à la ligne
    overflowWrap: "break-word",
    color: "#4e5d78",
  },
  text2: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal", // Autorise le retour à la ligne
    overflowWrap: "break-word",
    color: "#4e5d78",
  },
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    margin: theme.spacing(2, 0),
  },
  link: {
    cursor: "pointer",
    textDecoration: "inherit",
    "&.hover": {
      textDecoration: "underline",
    },
    "@media (max-width: 768px)": {
      textDecoration: "underline",
    },
  },
}));

interface AddCapitalPropsInterface {
  shares: Array<CreateUserInput>;
  refetch: (variables?: any) => Promise<any>;
  isIndividual: boolean;
  documentsType: (DocumentsType_documentsType | null)[];
  document: InputDocument | null;
  next: string;
  previous: string;
  activeGetId: boolean;
}

const AddPercent = (props: AddCapitalPropsInterface) => {
  const {
    shares,
    isIndividual,
    documentsType,
    document: _document,
    previous,
    next,
    activeGetId,
  } = props;

  const classes = styles();
  const client = useApolloClient();
  const navigate = useNavigate();

  const [isAdd, setIsAdd] = useState(false);
  const [document, setDocument] = useState<InputDocument | null>(_document);
  const [isConfirmed, setIsConfirmed] = useState(shares?.length > 1);
  const [accept, setAccept] = useState({
    isAgree: false,
    accept: false,
  });
  const [total, setTotal] = useState(0);
  const [shareList, setShareList] = useState<CreateUserInput[]>(shares);
  const [shareholder, setShareholder] = useState<CreateUserInput>({
    ...emptyShareholder,
  });
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState({
    email: "",
    phone: "",
    accountId: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmittedAddUpdate, setIsSubmittedAddUpdate] = useState(false);
  const [loading, setLoading] = useState(false);

  const uboDocumentType = documentsType?.find(
    (type) => type?.type === DocumentType.UBO_REGISTRY,
  );
  const identityDocumentType = documentsType?.filter(
    (type) =>
      type?.type === DocumentType.PASSPORT ||
      type?.type === DocumentType.DRIVING_LICENCE ||
      type?.type === DocumentType.IDENTITY_CARD ||
      type?.type === DocumentType.VISA ||
      type?.type === DocumentType.RESIDENCE_PERMIT,
  );
  const identitySelect: SelectItemInterface[] = [];
  identityDocumentType?.map((type) => {
    if (type?.type && type?.name) {
      identitySelect.push({ id: type.type, label: type.name });
    }
  });

  const { showErrorToast, showSuccessToast } = useToastNotifications();
  const [finishStep, { loading: finishStepLoading }] = useMutation<
    SignupProgression,
    SignupProgressionVariables
  >(SIGNUP_PROGRESSION, {
    onCompleted: () => {
      if (!isIndividual) {
        const cancelUrl = window.location.href;
        const successUrl = cancelUrl.replace(
          "shareholdersPercent",
          activeGetId ? "identity-verification" : "contrat",
        );
        createPayment({
          variables: {
            cancelUrl,
            successUrl,
          },
        });
      } else {
        handlePass();
      }
    },
    onError: (error) => {
      showErrorToast({ description: "server.error" });
    },
  });

  const [deleteUbo, { loading: deleteLoading }] = useMutation<
    DeleteMember,
    DeleteMemberVariables
  >(DELETE_MEMBER, {
    onError: (error) => {
      showErrorToast({ description: "member.error.deleteUser" });
    },
  });

  const [createShare, { loading: createLoading }] = useMutation<
    CreateUser,
    CreateUserVariables
  >(CREATE_USER, {
    onCompleted: (data) => {
      handleClose();
      setLoading(false);
      if (data?.createUser) {
        const newMember = mappedMember(data.createUser);
        const list = addOrUpdateObject(shareList, newMember);
        setShareList(list);
        showSuccessToast({
          description: "stepSix.success.addShareholder",
        });
        setIsSubmittedAddUpdate(false);
      }
    },
    onError: (error) => {
      setLoading(false);
      let message = "stepSix.error.addShareholder";
      if (
        error?.graphQLErrors?.[0]?.message === SapheerError.EMAIL_ALREADY_EXIST
      ) {
        message = "member.email.already.exists";
      } else if (
        error?.graphQLErrors?.[0]?.message === SapheerError.PHONE_ALREADY_EXIST
      ) {
        message = "member.phone.already.exists";
      }
      showErrorToast({ description: message });
    },
  });

  const [createPayment, { loading: stripeLoading }] = useMutation<
    CreatePaymentStripe,
    CreatePaymentStripeVariables
  >(CREATE_PAYMENT_STRIPE, {
    onCompleted: (url) => {
      if (url?.createPaymentStripe) {
        // Remplacement de history.push par navigate
        navigate("/shareholdersPercent", { replace: true });
        window.location.replace(url.createPaymentStripe);
      }
    },
    onError: (error) => {
      showErrorToast({ description: "create.payment.stripe.error" });
    },
  });

  const [savePercent, { loading: savePercentLoading }] = useMutation<
    SharesholdersPercents,
    SharesholdersPercentsVariables
  >(SHARESHOLDERS_PERCENTS, {
    onCompleted: () => {
      setLoading(false);
      showSuccessToast({
        description: "stepSix.success.addShareholderCapital",
      });
      if (!isIndividual) {
        const cancelUrl = window.location.href;
        const successUrl = cancelUrl.replace(
          "shareholdersPercent",
          activeGetId ? "identity-verification" : "contrat",
        );
        createPayment({
          variables: {
            cancelUrl,
            successUrl,
          },
        });
      } else {
        handlePass();
      }
    },
    onError: (error) => {
      setLoading(false);
      showErrorToast({ description: "stepSix.error.addShareholderPercent" });
    },
  });

  const handleNext = () => {
    setIsSubmitted(true);
    if (!isConfirmed) {
      return showErrorToast({ description: "stepFive.createPerson.accept" });
    }
    saveInformations();
  };

  const handleInsertNext = () => {
    if (isIndividual) {
      handleClose();
      setLoading(false);
      return;
    }
    setIsSubmittedAddUpdate(true);
    if (!accept.isAgree || !accept.accept) {
      return showErrorToast({ description: "stepFive.createPerson.accept" });
    }
    const {
      city,
      address,
      countryIsoCode,
      firstname,
      gender,
      name,
      nationalityCountryIsoCode,
      postcode,
      documents,
      specifiedUSPerson,
      email,
      mobilePhoneNumber,
      sharesPercentage,
      id,
      cityOfBirth,
      countryOfBirthIsoCode,
      dateOfBirth,
      isDirector,
      directorAppointmentDate,
    } = shareholder;
    // Validation des inputs
    if (!gender) {
      return showErrorToast({ description: "member.gender.empty" });
    }
    if (!name) {
      return showErrorToast({ description: "member.name.empty" });
    }
    if (!firstname) {
      return showErrorToast({ description: "member.firstname.empty" });
    }
    if (!nationalityCountryIsoCode) {
      return showErrorToast({ description: "member.nationality.empty" });
    }
    if (!specifiedUSPerson) {
      return showErrorToast({ description: "member.usPerson.empty" });
    }
    if (!address) {
      return showErrorToast({ description: "address.street.empty" });
    }
    if (!countryIsoCode || !countryOfBirthIsoCode) {
      return showErrorToast({ description: "address.isoCountryCode.empty" });
    }
    if (!postcode) {
      return showErrorToast({ description: "address.postalCode.empty" });
    }
    if (!city || !cityOfBirth) {
      return showErrorToast({ description: "address.city.empty" });
    }
    if (!mobilePhoneNumber) {
      return showErrorToast({ description: "member.phone.empty" });
    }
    if (!checkValidNumber(mobilePhoneNumber)) {
      return showErrorToast({
        description: "Votre numéro de téléphone n'est pas valide",
      });
    }
    if (!email) {
      return showErrorToast({ description: "member.email.empty" });
    }

    if (isDirector && !directorAppointmentDate) {
      return showErrorToast({
        description: "member.director.appointment.date.empty",
      });
    }

    if (documents?.length) {
      for (const document of documents) {
        if (document) {
          const { base64Content, type } = document;
          if (!base64Content) {
            return showErrorToast({ description: "member.doc.empty" });
          }
          if (!type) {
            return showErrorToast({ description: "member.doc.type.empty" });
          }
        }
      }
    }
    createShare({
      variables: {
        input: {
          id: isAdd ? null : id,
          city,
          firstname,
          gender,
          countryIsoCode,
          name,
          nationalityCountryIsoCode,
          postcode,
          address,
          email: email.toLowerCase().trim(),
          isLegalRepresentative: false,
          mobilePhoneNumber,
          cityOfBirth,
          countryOfBirthIsoCode,
          dateOfBirth,
          type: "UBO",
          specifiedUSPerson,
          documents,
          isDirector: !!isDirector,
          directorAppointmentDate,
          ...(sharesPercentage && { sharesPercentage }),
        },
      },
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsConfirmed(event.target.checked);
  };

  const isAllFieldSet = () => {
    let checkOneDirector = false;
    if (shareList?.length > 0) {
      for (const shareholder of shareList) {
        const { firstname, name, sharesPercentage, email, isDirector } =
          shareholder;
        if (!email) {
          return showErrorToast({ description: "shareholder.email.empty" });
        }
        if (!firstname) {
          return showErrorToast({
            description: "stepFive.form.empty.firstName",
          });
        }
        if (!name) {
          return showErrorToast({ description: "stepFive.form.empty.name" });
        }
        if (
          !sharesPercentage?.toString() ||
          (sharesPercentage && sharesPercentage < 0)
        ) {
          return showErrorToast({ description: "shareholder.percent.empty" });
        }
        if (isDirector) checkOneDirector = true;
      }
      if (!checkOneDirector) {
        return showErrorToast({ description: "shareholder.director.empty" });
      }
      return true;
    } else {
      return showErrorToast({ description: "shareholder.percent.noActionary" });
    }
  };

  const saveInformations = async () => {
    if (isAllFieldSet()) {
      const shares: any = shareList.map((sh) => {
        const { id, firstname, name, sharesPercentage, email } = sh;
        return {
          id,
          firstname,
          name,
          sharesPercentage,
          email,
        };
      });
      savePercent({
        variables: {
          shares,
          document,
        },
      });
    }
  };

  // Remplacez history.push par navigate
  const handlePrevious = () => {
    navigate(previous);
  };

  const handlePass = () => {
    navigate(next);
  };

  const handlePercentChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value: _value } = event.target;
      const updateShareholder: any[] = [...shareList];
      let value: any = _value;
      if (name !== "sharesPercentage") {
        if (updateShareholder[index]?.[name] !== undefined)
          updateShareholder[index][name] = value;
      } else {
        value = +_value;
        if (isNaN(value) || value < 0) {
          value = 0;
        }
        updateShareholder[index][name] = arroundNumber(value);
        let tempTotal = 0;
        updateShareholder.forEach((element: UserInfo) => {
          if (element?.sharesPercentage) {
            tempTotal += element.sharesPercentage;
          }
        });
        if (value && 100 < tempTotal) {
          const diff = tempTotal - 100;
          const tempValue = value - diff;
          updateShareholder[index][name] = arroundNumber(tempValue);
        }
        const total = arroundNumber(tempTotal) || 0;
        setTotal(100 - total);
      }
      setShareList(updateShareholder);
    };

  const handleAddShareholder = () => {
    if (isIndividual) return;
    setShareholder({ ...emptyShareholder });
    setAccept({
      accept: false,
      isAgree: false,
    });
    handleOpen(true);
  };

  const handleEditShareholder = (member: CreateUserInput) => () => {
    setShareholder(member);
    setAccept({
      accept: true,
      isAgree: true,
    });
    handleOpen(false);
  };

  const handleRemove = (member: CreateUserInput) => {
    const newList = shareList.filter(
      (m) =>
        m.id !== member.id &&
        m.name !== member.name &&
        m.firstname !== member.firstname,
    );
    if (member.id) {
      deleteUbo({ variables: { id: member.id } }).then(() =>
        setShareList(newList),
      );
    } else {
      setShareList(newList);
    }
  };

  const handleOpen = (isAdd: boolean) => {
    setIsAdd(isAdd);
    setOpen(true);
    setIsSubmittedAddUpdate(false);
  };

  const handleClose = () => {
    setIsSubmittedAddUpdate(false);
    setOpen(false);
    setAccept({
      accept: false,
      isAgree: false,
    });
  };

  const handleInputChange =
    (shareholderId: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value: _value, checked } = event.target;
      if (name === "specifiedUSPerson" || name === "isDirector") {
        setShareholder({ ...shareholder, [name]: checked });
      } else {
        setShareholder({ ...shareholder, [name]: _value });
      }
    };

  const handleSelect = (index: number) => (name: string, value: string) => {
    if (name === "identidyDoc") {
      return;
    }
    setShareholder({ ...shareholder, [name]: value });
  };

  const handleDateChange =
    (shareholderId: number) => (name: string, date: any) => {
      setShareholder({ ...shareholder, [name]: date });
    };

  const handleInfoChange =
    (shareholderId: number) => (evt: ChangeEvent<HTMLInputElement>) => {
      const { value, name } = evt.target;
      setInfo({ ...info, [name]: value });
    };

  const handlePhoneChange = (personId: number, phone: string) => {
    setInfo({ ...info, phone });
  };

  const handleAcceptChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setAccept({ ...accept, [name]: checked });
  };

  const filterIdentityDoc = (
    documents: (InputDocument | null)[] | null | undefined,
  ): InputDocument[] => {
    if (documents) {
      return documents.filter(
        (doc): doc is InputDocument =>
          doc !== null &&
          doc?.type !== DocumentType.PASSPORT &&
          doc?.type !== DocumentType.DRIVING_LICENCE &&
          doc?.type !== DocumentType.IDENTITY_CARD &&
          doc?.type !== DocumentType.VISA &&
          doc?.type !== DocumentType.RESIDENCE_PERMIT,
      );
    }
    return [];
  };

  const handleUpload = (
    type: string,
    files: FileInterfaceLinkcy[],
    docType?: string,
  ) => {
    const uploadPromises = files.map(async (file: FileInterfaceLinkcy) => {
      const base64File = await fileToBase64(file.file as unknown as File);
      return {
        type,
        base64Content: base64File,
        filename: file?.filename ?? file?.file?.name ?? "file",
        fileType: file?.filetype ?? file?.file?.type,
      };
    });
    Promise.all(uploadPromises)
      .then((newDocuments) => {
        if (newDocuments?.[0]) {
          if (type === DocumentType.UBO_REGISTRY) setDocument(newDocuments[0]);
          if (type === "IDENTITY_DOC") {
            setShareholder((prevShareholder) => ({
              ...prevShareholder,
              documents: [
                ...filterIdentityDoc(prevShareholder?.documents),
                {
                  ...newDocuments[0],
                  type: docType ?? shareholder?.documents?.[0]?.type,
                },
              ],
            }));
          }
        }
      })
      .catch((error) => {
        showErrorToast({ description: "file.upload.erro" });
      });
  };

  const handleRemoveFile = (type: string) => {
    if (type === DocumentType.UBO_REGISTRY) setDocument(null);
    if (type === "IDENTITY_DOC") {
      setShareholder((prevShareholder) => ({
        ...prevShareholder,
        documents: [...filterIdentityDoc(prevShareholder?.documents)],
      }));
    }
  };

  return (
    <Box className={classes.addCapital}>
      <Box className={classes.first}>
        <CustomButton
          type="button"
          variant="outline4"
          onClick={handleAddShareholder}
          label="owner.addButton"
          disabled={isIndividual}
          fullWidthMobile
        />
        <Box className={classes.sharesList} marginTop={1}>
          {shareList?.map((sh: CreateUserInput, index: number) => (
            <>
              <Box className={classes.sharesDetail}>
                {!sh.isLegalRepresentative && (
                  <Box className={classes.edit}>
                    <Link
                      className={classes.link}
                      onClick={handleEditShareholder(sh)}
                    >
                      <FormattedMessage id={sh?.id ? "edit" : "complete"} />
                    </Link>
                  </Box>
                )}
                <ShareholderPercent
                  key={`shareholder-${index}`}
                  index={index}
                  total={total}
                  shareholder={sh}
                  handleChange={handlePercentChange}
                  isSubmitted={isSubmitted}
                  isOwner={!!sh.isLegalRepresentative}
                  handleRemove={handleRemove}
                />
              </Box>
            </>
          ))}
        </Box>
        {uboDocumentType?.id && (
          <>
            <Typography className={classes.text}>
              Chargez le document relatif :
            </Typography>
            <Box marginTop={1}>
              <FileUploadLinkcy
                category={uboDocumentType?.type ?? ""}
                label={uboDocumentType?.name ?? ""}
                setDocument={(files) =>
                  handleUpload(uboDocumentType?.type ?? "", files)
                }
                isSubmitted={isSubmitted}
                fileData={document as unknown as undefined}
                onRemove={handleRemoveFile}
              />{" "}
            </Box>
          </>
        )}
        <CustomCheckBox
          allPointer
          name="accept"
          isSubmitted={isSubmitted}
          isChecked={isConfirmed}
          onCheck={handleChange}
          label={
            <Typography className={classes.text2}>
              <FormattedMessage id="addPercent.checkbox" />
            </Typography>
          }
          errorMessage={
            <FormattedMessage id="stepSix.error.addCapitalCheckbox" />
          }
        />
        <Box marginTop={2}>
          <Typography className={classes.text}>
            Afin de finaliser votre souscription, vous allez procéder au
            règlement des frais de dossier à l'étape suivante, indispensable
            pour valider votre engagement et la conformité du compte.
          </Typography>
        </Box>

        <Box className={classes.button}>
          <CustomButton
            type="button"
            variant="outline4"
            onClick={handlePrevious}
            label="button.previous"
            disabled={loading || savePercentLoading || stripeLoading}
            fullWidthMobile
          />
          <CustomButton
            type="button"
            variant="primary"
            onClick={handleNext}
            label="button.next"
            loading={loading || savePercentLoading || stripeLoading}
            fullWidthMobile
          />
        </Box>
      </Box>
      <AddUboModal
        information={shareholder}
        personId={isAdd && shareholder?.id ? +shareholder.id : 0}
        isSubmitted={isSubmittedAddUpdate}
        email={info.email}
        phone={info.phone}
        handleInputChange={handleInputChange}
        handleSelect={handleSelect}
        handleDateChange={handleDateChange}
        handleEmailChange={handleInfoChange}
        handlePhoneChange={handlePhoneChange}
        isAgree={accept.isAgree}
        handleIsAgreeChange={handleInputChange}
        isAccept={accept.accept}
        handleAcceptChange={handleAcceptChange}
        identitySelect={identitySelect}
        handleUpload={handleUpload}
        handleRemoveFile={handleRemoveFile}
        open={open}
        handleClose={handleClose}
        handleNext={handleInsertNext}
        isLoading={
          loading || createLoading || finishStepLoading || stripeLoading
        }
        isAdd={isAdd}
        setInformation={setShareholder}
        documentsType={documentsType}
      />
    </Box>
  );
};

export default AddPercent;
